<template>
    <div>
        <header class="d-md-flex d-sm-block justify-content-between text-md-left text-center p-3">

            <template v-if="$t('isgeo') == 1">
                <img src="../../assets/img/logo-wh.svg" width="170" class="">
            </template>
            <template v-else>
                <img src="../../assets/img/logoEn.png" height="80" class="mt-3">
            </template>
            <div :class="['text-right font-weight-bold title',{'font-size-title-for-eng mt-2 mb-3': $t('isgeo') == 0}]" v-html="$t('importantheadertext')">
                <!--შემუშავებულია <br/>
            საქართველოს დაზღვევის სახელმწიფო ზედამხედველობის <br/>
            სამსახურის უფროსის 2017 წლის 3 აპრილის <br/>
            N18 ბრძანების შესაბამისად-->
            </div>
        </header>
        <div style="background-color: #bd9bc5 ; height:10px;"> </div>
        <main :class="[{'font-size-for-eng': $t('isgeo') == 0},{'font-size-for-ge': $t('isgeo') == 1}]">
            <div class="text-center mt-3 font-weight-bolder"> </div>
            <b-row class="m-0">
                <b-col cols="12" class="text-center font-weight-bolder">
                    {{$t('importantextmhl',{policy: policy})}}
                    <!--წარმოადგენს N <span class="description-box-c">{{policy}}</span> დაზღვევის პოლისის/პირობების განუყოფელ ნაწილს-->
                </b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    {{$t('insurancefullname')}}
                </b-col>
                <b-col md="6" sm="12" class="mt-2 green-text font-weight-bold">{{$t('JSCardi')}}</b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">{{$t('insuranceface')}}</b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold">{{$t('autoinsurance')}}</b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    {{$t('exceptionalconditions')}}
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold">{{$t('article#5')}}</b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">
                        {{$t('obligationsinsurer')}}
                    </div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold" v-html="$t('articlesauto')">
                </b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    {{$t('termoftheinsurancecontract')}}
                </b-col>
                <b-col md="6" sm="12" class="mt-2 row">
                    <div class="green-box col-md-3 col-6 p-3">{{$t('from')}}</div>
                    <div class="p-3 col-md-3 col-6">{{start}}</div>
                    <div class="green-box col-md-3 col-6 p-3">{{$t('including')}}</div>
                    <div class="p-3 col-md-3 col-6">{{end}}</div>
                </b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">{{$t('cancelingagreement')}}</div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold" v-html="$t('articles2auto')">
                </b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">{{$t('ruleforfiling')}}</div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2" v-html="$t('mainrule')">

                </b-col>
                <!--item-->
                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">
                        {{$t('nameaddresssupervisoryauto')}}
                    </div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2">
                    {{$t('statesupervisionaddressauto')}}
                </b-col>

            </b-row>
        </main>
    </div>
</template>

<script>
export default {
  name: "ImportantConditions",
  props:['policy', 'start', 'end']

}
</script>

<style scoped>

header {
  background: #007a60 !important;
  color: #fafafa;
  /*box-shadow: 0 10px 0 #bd9bc5;*/
}
.title {
  font-size: 18px;
}

    @media print {
        .font-size-for-eng {
            font-size: 25px !important;
        }
        .font-size-title-for-eng {
            font-size: 22px !important;
        }
        .font-size-for-ge {
            font-size: 23px !important;
        }
        
    }

        .description-box-c {
            background: #e6e0ea !important;
            color: black !important;
        }

        .green-text {
            color: #00A886;
        }

        .green-box {
            background: #007a60 !important;
            color: #fafafa;
        }

        @media (max-width: 500px) {
            .title {
                font-size: 13px;
            }

        }
</style>